import { useGetProjectsQuery } from "../../../features/projects/projectsApi";
import ProjectItem from "./ProjectItem";

const ProjectList = () => {
  const { data: projects, isLoading, isError } = useGetProjectsQuery();

  // decide what to render
  let content = "";

  if (isLoading) {
    content = <div>Loading...</div>;
  }

  if (!isLoading && isError) {
    content = <div>There was an error!</div>;
  }

  if (!isLoading && !isError && projects?.length === 0) {
    content = <div>No projects found!</div>;
  }

  if (!isLoading && !isError && projects?.length > 0) {
    content = projects.map((project) => (
      <ProjectItem key={project.id} project={project} />
    ));
  }

  return (
    <div>
      <h3 className="text-xl font-bold">Projects</h3>
      <div className="mt-3 space-y-4">{content}</div>
    </div>
  );
};

export default ProjectList;
